var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponent8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_5982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8 11.5C21.8 5.53464 16.9653 0.699951 11 0.699951C5.03464 0.699951 0.199951 5.53464 0.199951 11.5C0.199951 16.8915 4.1487 21.3592 9.31245 22.1692V14.6218H6.57026V11.5H9.31245V9.12058C9.31245 6.41425 10.924 4.9187 13.392 4.9187C14.5732 4.9187 15.8093 5.12964 15.8093 5.12964V7.78745H14.4467C13.1051 7.78745 12.6875 8.62065 12.6875 9.47495V11.5H15.6828L15.2039 14.6218H12.6875V22.1692C17.8512 21.3592 21.8 16.8915 21.8 11.5Z",
    fill: "#ADADAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_5982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "translate(0.199951 0.699951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent8);
export default __webpack_public_path__ + "static/media/Component 8.3e1a39c44bba01eade7f9a65efd37cfe.svg";
export { ForwardRef as ReactComponent };